import Product_Keikakumeisai from '../classes/Product_Keikakumeisai.js';

export function ImportKeikakumeisaiData(sheet)
{
    console.log('import keikakumeisai', sheet);
    let container = document.createElement('div');
    document.body.append(container);

    //const lastCol = sheet.lastColumn.number;
    const lastRow = sheet.lastRow.number;

    console.log('last row ' + sheet.lastRow, sheet.lastRow);

    const products = [];
    const missingStyleNumberInfo = [];

    for(let i = 4; i < lastRow; i++)
    {
        const r = sheet.getRow(i);
        if (r.getCell(3).value === null)
        {
            // No product found, we are done
            break;
        }

        const prod = new Product_Keikakumeisai(r);

        // Skip products without stylenumber
        // as they'll "break" the database data.
        // Data from Keikakumeisai and Zaikomeisai
        // is being merged and if the Keikakumeisai
        // products don't have a stylenumber, we can't
        // link the Zaikomeisai data anymore, resulting
        // in duplicated products that should be one
        // and products that'll never get a stylenumber,
        // JAN or serial number assigned.
        if (prod.StyleNumber === '' ||
            prod.StyleNumber === null ||
            prod.StyleNumber === undefined)
        {
            missingStyleNumberInfo.push({ Row: i, Name: prod.ProductName });
            continue;
        }
        // console.log('(Keikakumeisai) #' + r.number, prod);
        products.push(prod);
    }

    return { products, missingStyleNumberInfo };
}

export function ColumnToNumber(columnString)
{
    columnString = columnString.toUpperCase(); // Ensure uppercase for consistency
  
    let number = 0;
    for (let i = 0; i < columnString.length; i++) {
      const charCode = columnString.charCodeAt(i);
      const offset = charCode - 65; // Offset from 'A' (65)
  
      // Consider single-digit columns (A-Z) and multi-digit columns (AA, AB, etc.)
      number = (number * 26) + (offset + 1);
    }
  
    return number;
}

export function NumberToColumn(number)
{
    var n = (number - 1) % 26;
    var c = String.fromCharCode(65 + n);
    var n2 = Math.floor((number - 1) / 26);
    if (n2 > 0) {
        return NumberToColumn(n2) + c;
    } else {
        return c;
    }
}